import { 
  ICMemo, 
  RecommendationType, 
  DecisionType, 
  VoteType, 
} from '../../types';

// Mock IC Memos
export const mockICMemos: ICMemo[] = [
  {
    id: '1',
    dealName: 'Parkview Apartments Acquisition',
    assetName: 'Parkview Apartments',
    fund: 'Fund III',
    date: '2024-04-05',
    recommendation: RecommendationType.Buy,
    decision: DecisionType.Approved,
    summary: 'Recommend purchase-critiquen, property. Expected IRR at 5.5%, 5-year hold',
    underwritingAssumptions: [
      '$2.3M CapEx',
      '5.4% exit cap rate',
      '3.0% rent growth'
    ],
    attachments: [
      {
        id: 'a1',
        name: 'IC_Memo_Parkview.pdf',
        type: 'application/pdf',
        url: '/documents/IC_Memo_Parkview.pdf'
      },
      {
        id: 'a2',
        name: 'Underwriting_Model.xlsx',
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        url: '/documents/Underwriting_Model.xlsx'
      }
    ],
    votes: [
      {
        id: 'v1',
        userId: '1',
        userName: 'Alice Martin',
        vote: VoteType.Yes,
        rationale: 'Strong market fundamentals and attractive entry basis.',
        timestamp: '2024-04-05T14:30:00Z'
      },
      {
        id: 'v2',
        userId: '2',
        userName: 'David Liu',
        vote: VoteType.Yes,
        rationale: 'Agree with the acquisition thesis. Good comp to our Westlake property.',
        timestamp: '2024-04-05T15:15:00Z'
      },
      {
        id: 'v3',
        userId: '3',
        userName: 'Sarah Jones',
        vote: VoteType.No,
        rationale: "Concerned about the market's absorption of new supply coming online in Q3.",
        timestamp: '2024-04-05T16:00:00Z'
      },
      {
        id: 'v4',
        userId: '4',
        userName: 'Michael Green',
        vote: VoteType.Abstain,
        rationale: 'Recusing due to prior relationship with seller.',
        timestamp: '2024-04-05T13:45:00Z'
      }
    ],
    versions: [
      {
        id: 'mv1',
        version: 1,
        date: '2024-04-01T09:00:00Z',
        updatedBy: 'John Smith',
        changes: ['Initial draft']
      },
      {
        id: 'mv2',
        version: 2,
        date: '2024-04-03T11:30:00Z',
        updatedBy: 'John Smith',
        changes: ['Updated financial projections', 'Added market analysis section']
      },
      {
        id: 'mv3',
        version: 3,
        date: '2024-04-04T16:45:00Z',
        updatedBy: 'Emily Davis',
        changes: ['Final review', 'Added executive summary', 'Updated exit assumptions']
      }
    ]
  },
  {
    id: '2',
    dealName: 'Brookfield Tower Acquisition',
    assetName: 'Brookfield Tower',
    fund: 'Fund III',
    date: '2024-04-05',
    recommendation: RecommendationType.Buy,
    decision: DecisionType.Rejected,
    summary: 'Class A office tower in downtown financial district. 92% occupied with credit tenants.',
    underwritingAssumptions: [
      '$4.5M TI/LC budget',
      '5.75% exit cap rate',
      '2.5% rent growth',
      '95% stabilized occupancy'
    ],
    attachments: [
      {
        id: 'a3',
        name: 'IC_Memo_Brookfield.pdf',
        type: 'application/pdf',
        url: '/documents/IC_Memo_Brookfield.pdf'
      },
      {
        id: 'a4',
        name: 'Brookfield_Model.xlsx',
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        url: '/documents/Brookfield_Model.xlsx'
      }
    ],
    votes: [
      {
        id: 'v5',
        userId: '1',
        userName: 'Alice Martin',
        vote: VoteType.No,
        rationale: 'Concerns about office sector fundamentals and WFH trends.',
        timestamp: '2024-04-05T14:00:00Z'
      },
      {
        id: 'v6',
        userId: '2',
        userName: 'David Liu',
        vote: VoteType.No,
        rationale: "Pricing doesn't adequately reflect lease rollover risk in years 3-4.",
        timestamp: '2024-04-05T14:30:00Z'
      },
      {
        id: 'v7',
        userId: '3',
        userName: 'Sarah Jones',
        vote: VoteType.No,
        rationale: 'Exit cap rate assumption too aggressive given market trends.',
        timestamp: '2024-04-05T15:00:00Z'
      },
      {
        id: 'v8',
        userId: '4',
        userName: 'Michael Green',
        vote: VoteType.Yes,
        rationale: 'Trophy asset with strong tenant roster. Rare acquisition opportunity.',
        timestamp: '2024-04-05T15:30:00Z'
      }
    ],
    versions: [
      {
        id: 'mv4',
        version: 1,
        date: '2024-04-02T10:15:00Z',
        updatedBy: 'Emily Davis',
        changes: ['Initial draft']
      },
      {
        id: 'mv5',
        version: 2,
        date: '2024-04-04T09:30:00Z',
        updatedBy: 'Emily Davis',
        changes: ['Updated tenant analysis', 'Revised capital expenditure schedule']
      }
    ]
  },
  {
    id: '3',
    dealName: 'Terra Vista Disposition',
    assetName: 'Terra Vista',
    fund: 'Fund II',
    date: '2024-03-15',
    recommendation: RecommendationType.Sell,
    decision: DecisionType.Approved,
    summary: 'Recommend sale of Terra Vista retail center after 5-year hold period. Value-add program complete.',
    underwritingAssumptions: [
      '$32.5M sale price (5.25% cap rate)',
      '1.8x equity multiple achieved',
      '16.7% IRR realized'
    ],
    attachments: [
      {
        id: 'a5',
        name: 'IC_Memo_TerraVista_Exit.pdf',
        type: 'application/pdf',
        url: '/documents/IC_Memo_TerraVista_Exit.pdf'
      }
    ],
    votes: [
      {
        id: 'v9',
        userId: '1',
        userName: 'Alice Martin',
        vote: VoteType.Yes,
        rationale: 'Achieved business plan and returns exceed original underwriting.',
        timestamp: '2024-03-15T11:00:00Z'
      },
      {
        id: 'v10',
        userId: '2',
        userName: 'David Liu',
        vote: VoteType.Yes,
        rationale: 'Good time to exit given retail market uncertainty.',
        timestamp: '2024-03-15T11:30:00Z'
      },
      {
        id: 'v11',
        userId: '3',
        userName: 'Sarah Jones',
        vote: VoteType.Yes,
        rationale: 'Strong execution of business plan. Recommend proceeding with sale.',
        timestamp: '2024-03-15T12:00:00Z'
      }
    ],
    versions: [
      {
        id: 'mv6',
        version: 1,
        date: '2024-03-10T14:00:00Z',
        updatedBy: 'John Smith',
        changes: ['Initial draft']
      },
      {
        id: 'mv7',
        version: 2,
        date: '2024-03-12T16:30:00Z',
        updatedBy: 'John Smith',
        changes: ['Added broker feedback', 'Updated market comps']
      }
    ]
  },
  {
    id: '4',
    dealName: 'Grand Plaza Acquisition',
    assetName: 'Grand Plaza',
    fund: 'Fund II',
    date: '2024-02-20',
    recommendation: RecommendationType.Buy,
    decision: DecisionType.Approved,
    summary: 'Mixed-use development in high-growth submarket. 85% pre-leased with strong anchor tenants.',
    underwritingAssumptions: [
      '$78.5M purchase price',
      '4.9% going-in cap rate',
      '6.0% exit cap rate',
      '3.2% average rent growth',
      '7-year hold period'
    ],
    attachments: [
      {
        id: 'a6',
        name: 'IC_Memo_GrandPlaza.pdf',
        type: 'application/pdf',
        url: '/documents/IC_Memo_GrandPlaza.pdf'
      },
      {
        id: 'a7',
        name: 'GrandPlaza_Model.xlsx',
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        url: '/documents/GrandPlaza_Model.xlsx'
      }
    ],
    votes: [
      {
        id: 'v12',
        userId: '1',
        userName: 'Alice Martin',
        vote: VoteType.Yes,
        rationale: 'Strong demographics and tenant mix. Attractive basis.',
        timestamp: '2024-02-20T10:00:00Z'
      },
      {
        id: 'v13',
        userId: '2',
        userName: 'David Liu',
        vote: VoteType.Yes,
        rationale: 'Good diversification for the fund. Like the mixed-use component.',
        timestamp: '2024-02-20T10:30:00Z'
      },
      {
        id: 'v14',
        userId: '3',
        userName: 'Sarah Jones',
        vote: VoteType.Yes,
        rationale: 'Solid anchor tenants with long-term leases. Support acquisition.',
        timestamp: '2024-02-20T11:00:00Z'
      }
    ],
    versions: [
      {
        id: 'mv8',
        version: 1,
        date: '2024-02-15T09:45:00Z',
        updatedBy: 'Emily Davis',
        changes: ['Initial draft']
      },
      {
        id: 'mv9',
        version: 2,
        date: '2024-02-18T14:15:00Z',
        updatedBy: 'Emily Davis',
        changes: ['Updated financial analysis', 'Added competitive set analysis']
      }
    ]
  }
];
